import { useMemo, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import queryString from "qs";

export function useRouterWeb() {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Helper function to create a URL from a pathname and query parameters.
  const createUrl = (pathname, query = {}) => {
    // Check if query object is empty
    if (Object.keys(query).length === 0) {
      return pathname;
    }
    
    const queryStringified = queryString.stringify(query);
    return queryStringified ? `${pathname}?${queryStringified}` : pathname;
  };

  // Memoize the router object to prevent unnecessary re-renders
  const router = useMemo(() => {
    return {
      // For convenience add push(), replace(), pathname at top level
      navigate: (pathname, query = {}) => {
        const url = createUrl(pathname, query);
        navigate(url);
      },
      pathname: location.pathname,
      // Merge params and parsed query string into single "query" object
      query: {
        ...params,
        ...queryString.parse(location.search.substring(1)), // Convert string to object
      },
      // Include match, location, history objects so caller
      // can use object destructuring to get anything needed
      location,
      history: navigate,
    };
  }, [navigate, location, params]);

  return router;
}
